import create from "zustand"
import { STLExporter } from "three/examples/jsm/exporters/STLExporter.js"

const useStore = create((set, get) => ({
  svg: "",

  mesh: null,
  setMesh: mesh => set({ mesh }),
  setSVG: (svg, face, name, items) => {
    get().faces[face - 1].svg = svg
    get().faces[face - 1].iconName = name
    get().faces[face - 1].fabric = items
    set({ svg })
    //set(state => ({ faces: [svg, ...get().faces[face].svg] }))
  },
  setOpen: open => set({ open }),
  open: false,
  exportSTL: mesh => {
    const exporter = new STLExporter()

    // update before export -> inver or scale
    //  mesh.current.rotation.x = Math.PI * 0.5
    //mesh.current.scale.set(2.2, 2.2, 2.2)
    //   mesh.current.updateMatrixWorld()
    const result = exporter.parse(mesh.current)
    const blob = new Blob([result], { type: "application/octet-stream" })
    const link = document.createElement("a")
    link.style.display = "none"
    document.body.appendChild(link)
    link.href = URL.createObjectURL(blob)
    link.download = "Dice.stl"
    link.click()
    // mesh.current.rotation.x = Math.PI
    //mesh.current.scale.set(2.2, 2.2, 2.2)
    // mesh.current.updateMatrixWorld()
  },
  face: [],
  allIcons: [],
  currentFace: 1,
  faces: [],
  setFaces: face => set({ faces: face }),
  setCurrentFace: face => set({ currentFace: face }),
  setAllIcons: icons => set({ allIcons: icons }),
  setCameraFace: face => set({ face }),
}))

export { useStore }
